export const RESET = 'EXSBINVOICESTATUS_LIST_RESET'
export const SET_ITEMS = 'EXSBINVOICESTATUS_LIST_SET_ITEMS'
export const SET_ERROR = 'EXSBINVOICESTATUS_LIST_SET_ERROR'
export const SET_VIEW = 'EXSBINVOICESTATUS_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXSBINVOICESTATUS_LIST_TOGGLE_LOADING'
